import React,{useEffect} from 'react'
import { useParams , useNavigate } from 'react-router';


import axios from 'axios';
import { CircularProgress } from '@mui/material';

axios.defaults.baseURL = "https://auth-k.gtoken.in/";

function PortalGrievanceLandingPage() {

    let { portalId,gid } = useParams();
    const navigate = useNavigate();


    const setAppPortal = async (portal) =>{
        localStorage.setItem("portalUrl",portal.url);
        localStorage.setItem("portalTitle",portal.title);
        localStorage.setItem("portalId",portal.portalId);
        //localStorage.setItem("notificationUrl",portal.notificationUrl);
        //navigate("/auth/login");
        window.location.reload();
    }


    const setPortal = (portalId) =>{
        console.log("portal id is "+portalId);
        let _portalDetails = null;
        if(portalId == "local-demo1"){
            _portalDetails = {url:"http://localhost:8008",portalId:"local-demo1",title:"Local Demo1 @ 8008"}
        }
        if(portalId == "local-demo2"){
            _portalDetails = {url:"http://localhost:8008",portalId:"local-demo2",title:"Local Demo2 @ 8008"}
        }
        if(portalId == "global-demo1"){
            _portalDetails = {url:"https://whatsapp-api.globalinc.co.in",portalId:"global-demo1",title:"Global Demo1"}
        }

        if(portalId == "global-demo2"){
            _portalDetails = {url:"https://whatsapp-api.globalinc.co.in",portalId:"global-demo2",title:"Nagar Nigam Demo"}
        }

        setAppPortal(_portalDetails);
        /*
        axios.post("/portal/verify",{portalId:portalId}).then(res=>{
            if(res.data.error){
                console.log("No Portal found")
            } else {
                localStorage.setItem("portalId",portalId);
                localStorage.setItem("portalUrl",res.data.data.url);
                localStorage.setItem("portalTitle",res.data.data.title);
                localStorage.setItem("notificationUrl",res.data.data.notificationUrl);
                window.location.reload();
            }
        }).catch(error=>{    
        })s
        */
    }


    const getPortal =() =>{
        console.log(portalId )
        if(portalId != localStorage.portalId){
            setPortal(portalId);
        } else {
            if(localStorage.portalUrl != undefined) {
                console.log("ready");
                navigate("/portal/complaint/details/"+gid)
            }
        }
    }
    useEffect(()=>{
        getPortal()
    },[])



    
    return (
        <div className="container">
            <div className="row mt-5">
                <div className='col-md-12 text-center'>
                    <img src='/images/gtoken-logo.jpg' style={{width:"30%"}} />
                </div>
                <div className="col-md-12 text-center">
                    <CircularProgress/>
                </div>
            </div>
        </div>


    )
}

export default PortalGrievanceLandingPage